<template>
  <div>
    <v-footer
    padless
    elevation="3"
    >
      <v-card
      tile
      width="100%"
      color="#1a3057"
      v-if="$store.state.mode !== 'ats' && $store.state.mode !== 'adam' && $store.state.mode !== 'atsDev' && $store.state.mode !== 'adamDev'"
      >
        <v-card-text>
          <v-container fluid>
            <v-row justify="space-between">
              <v-col cols="12" sm="6" md="3">
                <v-img src="../static/logo.png" width="100"></v-img>
                <p class="body-2 mt-5 pr-5 white--text">
                  Fare 33 was established by experts with over 30 years of experience in multiple facets of the travel industry. Our team has been involved in the evolution of the technological advancement of ticketing from the very beginning. With that knowledge and years of experience with the airlines, we are uniquely situated to provide you with the best prices and the smoothest user experience in the market.
                </p>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <span class="white--text font-weight-bold" style="font-size: 20px;">Easy Access</span>
                <hr class="divider">
                <ul class="links-list">
                  <li>
                    <router-link to="/about">About</router-link>
                  </li>
                  <li>
                    <router-link to="/flights">Flights</router-link>
                  </li>
                  <li>
                    <router-link to="/hotels">Hotels</router-link>
                  </li>
                  <li>
                    <router-link to="/cars">Cars</router-link>
                  </li>
                  <li>
                    <router-link to="/help">Customer Service</router-link>
                  </li>
                </ul>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <span class="white--text font-weight-bold" style="font-size: 20px;">Legal & Rewards</span>
                <hr class="divider">
                <ul class="links-list">
                  <li>
                    <router-link to="/terms">Terms & conditions</router-link>
                  </li>
                  <li>
                    <router-link to="/privacy">Privacy Policy</router-link>
                  </li>
                  <li>
                    <router-link to="/rewards">Rewards</router-link>
                  </li>
                </ul>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <span class="white--text font-weight-bold" style="font-size: 20px;">Contacts</span>
                <hr class="divider">
                <div class="my-5">
                  <v-icon color="white">mdi-phone</v-icon>
                  <span class="ml-3 white--text caption">(+1) 305-498-4879</span>
                </div>
                <div class="my-5">
                  <v-icon color="white">mdi-email-open</v-icon>
                  <span class="ml-3 white--text caption">info@Fare33.com</span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <hr style="background-color: grey; border: none; height: 0.5px; margin: 20px">
        <v-row justify="space-between" class="pa-5" no-gutters>
          <div>
            <a v-for="item in social" class="mr-5 social-links" :key="item.icon" :href="item.link" target="_blank"><v-icon :color="item.color">{{item.icon}}</v-icon></a>
          </div>
          <p class="bod-2 grey--text text-right mr-5">
            &copy; {{ new Date().getFullYear() }} All rights reserved. Fare33
          </p>
        </v-row>
      </v-card>
      <v-card
        tile
        width="100%"
        color="#1F2746"
        v-if="$store.state.mode === 'ats' || $store.state.mode === 'atsDev'"
      >
        <v-card-text>
          <v-container fluid>
            <v-row justify="space-between">
              <v-col cols="12" sm="6" md="3">
                <span class="display-1 font-weight-bold white--text">ATS Fares</span>
                <p class="body-2 mt-5 grey--text">
                  ATS is a leading air fare consolidator, deliver the best fares, products, service, and opportunities to travel suppliers, partners, and vendors looking to improve their services and expand their business Working with more than 50+ carriers and being in business since 84' makes us truly your global partner.
                </p>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <span class="white--text font-weight-bold" style="font-size: 20px;">Accredited by</span>
                <hr class="divider">
                <v-img src="../static/arc.png" max-width="100" class="my-5"></v-img>
                <div style="margin-top: 50px;">
                  <v-img src="../static/iata.png" max-width="100" class="my-5"></v-img>
                </div>
              </v-col>
              <v-col cols="6" sm="6" md="3">
                <span class="white--text font-weight-bold" style="font-size: 20px;">Supported GDS's</span>
                <hr class="divider">
                <v-img src="../static/logos.png" max-width="150" class="my-5"></v-img>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <span class="white--text font-weight-bold" style="font-size: 20px;">Contacts</span>
                <hr class="divider">
                <div class="my-5">
                  <v-icon color="white">mdi-map-marker</v-icon>
                  <span class="ml-3 white--text caption">131 West 33rd St. unit 10D, New York NY-10001</span>
                </div>
                <div class="my-5">
                  <v-icon color="white">mdi-phone</v-icon>
                  <span class="ml-3 white--text caption">1- 833-287-3273</span>
                </div>
                <div class="my-5">
                  <v-icon color="white">mdi-email-open</v-icon>
                  <span class="ml-3 white--text caption">support@atsfares.com</span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <hr style="background-color: grey; border: none; height: 0.5px; margin: 20px">
        <p class="bod-2 grey--text text-right mr-5">
          &copy; {{ new Date().getFullYear() }} All rights reserved. <a href="https://atsfares.com/page.php?privacy" class="privacy-link" target="_blank">Privacy Policy</a>
        </p>
      </v-card>
      <v-card
        tile
        width="100%"
        color="#1a3057"
        class="adam-footer"
        v-if="$store.state.mode === 'adam' || $store.state.mode === 'adamDev'"
      >
        <v-card-text>
          <v-container>
            <v-row justify="space-between">
              <v-col cols="12" sm="5" class="text-center">
                <p class="headline grey--text">Adam Travel Services</p>
                <p class="subtitle-1 grey--text">YOUR TRAVEL PARTNER FOR OVER 32 YEARS</p>
                <p class="body-2 mt-5 grey--text">
                  Adam Travel is one of the nation's largest consolidators offering a variety of products and services for all of your travel needs.
                </p>
                <p class="body-2 mt-5 grey--text">
                  In addition to airfares, Adam Travel is a large tour provider offering vacation packages across the globe as well as Hajj and Umrah packages.
                </p>
              </v-col>
              <v-divider vertical style="background-color: grey;"></v-divider>
              <v-col cols="12" sm="5" class="text-center">
                <a href="https://adamtravel.com/flight-club/">
                  <v-img src="../static/adam/logo-footer.jpg" max-width="50%" class="my-5 mx-auto"></v-img>
                </a>
                <p class="display-1 mt-5 white--text font-weight-bold">JOIN US SAVE BIG</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <hr style="background-color: grey; border: none; height: 0.5px; margin: 20px">
        <v-card-actions>
          <v-container>
            <v-row justify="space-between" class="my-5">
              <div class="social-adam-cont">
                <a href="https://www.facebook.com/AdamTravelServices/" target="_blank"><div class="social-adam"><span>f</span></div></a>
                <a href="https://twitter.com/adamtravelusa" target="_blank"><div class="social-adam"><v-icon class="mt-1" color="#1a3057">mdi-twitter</v-icon></div></a>
                <a href="https://www.instagram.com/adamtravelusa/" target="_blank"><div class="social-adam"><v-icon class="mt-1" color="#1a3057">mdi-instagram</v-icon></div></a>
              </div>
              <div class="supp-adam-cont">
                <img src="../static/adam/discover.jpg" height="40px" class="mr-5">
                <img src="../static/adam/express.jpg" height="40px" class="mr-5">
                <img src="../static/adam/master.jpg" height="40px" class="mr-5">
                <img src="../static/adam/visa.jpg" height="40px" class="mr-5">
                <img src="../static/adam/arc.jpg" height="40px" class="mr-5">
                <img src="../static/adam/iatan.jpg" height="40px" class="mr-5">
              </div>
              <p class="caption grey--text text-right mt-3">
                &copy; {{ new Date().getFullYear() }} Adam Travel Services Inc All Right Reserved.
              </p>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-footer>
    <v-dialog
    v-model="dialog1"
    scrollable
    width="50%"
    >
      <v-card>
        <v-card-title
          class="headline secondary white--text"
          secondary-title
        >
          Mobile Applications
          <v-spacer></v-spacer>
          <v-icon large color="white" @click="dialog1 = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <p class="headline text-center font-weight-medium secondary--text mt-3">Coming Soon!</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      dialog1: false,
      title: '',
      social: [
        { icon: 'mdi-facebook', link: 'https://www.facebook.com/Fare33TravelServices', color: '#1877f2' },
        { icon: 'mdi-twitter', link: 'https://twitter.com/fare33_info', color: '#1da1f2' },
        { icon: 'mdi-instagram', link: 'https://www.instagram.com/fare33.info/', color: '#c32aa3' }
      ]
    }
  },
  methods: {
    goTo (page) {
      this.$router.push({ name: page })
    }
  }
}
</script>

<style scoped>
  .download-link {
    text-decoration: none;
    font-weight: 700;
    font-size: 1rem;
  }
  .details {
    font-size: 11px;
    margin-right: 15px;
  }
  h3 {
    font-size: 15px;
  }
  ul {
    list-style: none;
  }
  .social-links {
    text-decoration: none;
  }
  .list-items {
    text-decoration: none;
    color: grey;
    font-size: 12px;
    transition: .2s linear;
  }
  .list-items:hover {
    color: white;
    font-weight: bold;
    cursor: pointer;
  }
  .subscripe {
    min-height: 220px;
    position: relative;
  }
  .btn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .divider {
    background-color:#42D4EC;
    width: 50px;
    height: 3px;
    margin-top: 5px;
    border: none;
  }
  .privacy-link {
    color: grey;
    text-decoration: none;
  }
  .privacy-link:hover {
    cursor: pointer;
    color: white;
  }
  .adam-footer {
    border-top: 3px solid #FDB71A !important;
  }
  .social-adam-cont {
    display: flex;
    margin-top: 5px;
  }
  .social-adam {
    background-color: #FDB71A;
    height: 30px;
    width: 30px;
    margin-right: 5px;
    text-align: center;
  }
  .social-adam:hover {
    background-color: #f1ad1a;
  }
  .social-adam span {
    color: #1a3057;
    font-size: 1.3rem;
    font-weight: 900;
  }
  .social-adam-cont a {
    text-decoration: none;
  }
  @media screen and (max-width: 960px) {
    .brand {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .details {
      margin-top: 50px;
      text-align: center;
    }
    ul {
      text-align: center;
      margin: 20px;
    }
  }
  @media screen and (max-width: 526px) {
    ul {
     list-style: disc;
    }
  }
  .links-list {
    list-style: none;
    margin-top: 20px;
    padding-left: 0px;
  }
  .links-list li {
    margin: 10px 0;
    text-align: left;
  }
  .links-list li a {
    color: white;
    text-decoration: none;
    font-weight: bold;
    font-size: 18px;
  }
</style>
